module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_blank-a429a04e5840fc31e54fa97d27a6a1b7.png";